<template>
  <b-container fluid class="accordion-panel">
    <b-row
      class="accordion-panel__header py-2 px-3 print"
      align-h="between"
      align-v="center"
      :style="{background: background}"
      :class="headerClass"
    >
      <div
        class="accordion-panel__clickable-area"
        :class="{'accordion-panel__clickable-area-with-controls': hasControlsSlot}"
        @click="changeCollapsed(!collapsed)"
      />
      <b-col cols="11" class="accordion-panel__title-container">
        <slot name="title"/>
      </b-col>
      <div class="accordion-panel__right-controls">
        <b-container>
          <b-row align-h="end" align-v="center">
            <b-col
              cols="1"
              @click="changeCollapsed(!collapsed)"
            >
              <s-collapse-expand-button
                class="accordion-panel__arrow"
                :value="!collapsed"
              />
            </b-col>
            <b-col
              v-if="hasControlsSlot"
              cols="2"
            >
              <b-dropdown
                variant="link"
                no-caret
                right
              >
                <template slot="button-content">
                  <s-icon
                    name="options-menu"
                    class="ml-1"
                  />
                </template>
                <slot name="controls"/>
              </b-dropdown>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-row>
    <b-row class="accordion-panel__body">
      <b-collapse
        class="w-100"
        :id="id"
        :visible="!collapsed"
        @shown="onShown"
      >
        <div :class="withMarginClassOrNot">
          <slot/>
        </div>
      </b-collapse>
    </b-row>
  </b-container>
</template>

<script>
import clone from 'lodash/clone';
import { mapGetters } from 'vuex';
import themeService from '@/services/themeService';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
    },
    expandOnPrint: {
      type: Boolean,
      default: true,
    },
    withMarginHeader: {
      type: Boolean,
      default: true,
    },
  },
  data: vm => ({
    isCollapsed: vm.collapsed,
  }),
  computed: {
    ...mapGetters([
      'isPrinting',
    ]),
    hasControlsSlot() {
      return this.$slots.controls !== undefined;
    },
    withMarginClassOrNot() {
      return this.withMarginHeader ? 'my-2 mx-3 accordion-panel__slot-container' : 'mr-1 mt-2 accordion-panel__slot-container';
    },
    background() {
      return themeService.isDarkTheme() ? 'var(--color-background-dark)' : 'var(--color-neutral-background)';
    },
  },
  methods: {
    onBeforePrint() {
      if (!this.expandOnPrint) return;
      this.$nextTick(() => {
        this.openAccordion(true);
      });
    },
    onAfterPrint() {
      if (!this.expandOnPrint) return;
      this.$nextTick(() => {
        this.$emit('update:collapsed', this.isCollapsed);
      });
    },
    openAccordion(isPrinting = false) {
      if (isPrinting) {
        this.$emit('update:collapsedprint', false);
      } else {
        this.$emit('update:collapsed', false);
      }
    },
    changeCollapsed(value) {
      this.isCollapsed = clone(value);
      this.$emit('update:collapsed', value);
    },
    onShown() {
      this.$emit('shown');
    },
  },
  watch: {
    isPrinting(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.onBeforePrint();
      }
      if (!newValue && oldValue) {
        this.onAfterPrint();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  ::v-deep .b-table-sticky-header
    max-height: 38rem

  .print
    page-break-inside: avoid
    avoid-break-inside: avoid
  .accordion-panel
    box-shadow: 1px 1px 1px var(--color-background-dark)
    &__header
      background-color: var(--color-background-light)
      cursor: pointer
      border-top-left-radius: 5px
      border-top-right-radius: 5px
      position: relative
    &__title-container
      max-width: calc(100%)
      padding-left: 0 !important
      padding-right: 0 !important
    &__right-controls
      width: 60px
    &__arrow
      z-index: 2
      width: 14px
    &__body
      border-bottom-left-radius: 5px
      border-bottom-right-radius: 5px
    &__clickable-area
      position: absolute
      width: 100%
      height: 100%
      z-index: 1
      margin-left: -15px
      &-with-controls
        width: calc(100% - 20px)
</style>
